import React from 'react';
import PropTypes from 'prop-types';

import { PublicWebsiteNav } from './index';

class PublicWebsiteNavContainer extends React.Component {
  state = { isMobileNavVisible: false };

  toggleMobileNavVisible = () => {
    const { isMobileNavVisible } = this.state;
    if (isMobileNavVisible) {
      document.body.classList.remove('lockScroll');
    } else {
      document.body.classList.add('lockScroll');
    }
    this.setState({ isMobileNavVisible: !isMobileNavVisible });
  };

  render() {
    const { isMobileNavVisible } = this.state;
    const {
      campaigns,
      isAllowedToSeeMoneyNavItem,
      onLogOut,
      user,
      podcastNetwork,
      onClickNavItem,
      pathname,
      isAmp,
      podcastName,
      podcastImage,
    } = this.props;
    return (
      <PublicWebsiteNav
        isAmp={isAmp}
        pathname={pathname}
        isAllowedToSeeMoneyNavItem={isAllowedToSeeMoneyNavItem}
        user={user}
        onLogOut={onLogOut}
        podcastNetwork={podcastNetwork}
        onClickNavItem={onClickNavItem}
        campaigns={campaigns}
        toggleMobileWebsiteNavVisible={this.toggleMobileNavVisible}
        isMobileNavVisible={isMobileNavVisible}
        podcastName={podcastName}
        podcastImage={podcastImage}
      />
    );
  }
}

PublicWebsiteNavContainer.propTypes = {
  isAmp: PropTypes.bool,
  isAllowedToSeeMoneyNavItem: PropTypes.bool.isRequired,
  onLogOut: PropTypes.func.isRequired,
  user: PropTypes.shape({
    imageUrl: PropTypes.string,
    userId: PropTypes.number,
    email: PropTypes.string,
    name: PropTypes.string,
  }),
  podcastNetwork: PropTypes.bool,
  onClickNavItem: PropTypes.func.isRequired,
  campaigns: PropTypes.arrayOf(
    PropTypes.shape({
      campaignStatus: PropTypes.string,
    })
  ),
  pathname: PropTypes.string,
  podcastName: PropTypes.string,
  podcastImage: PropTypes.string,
};

PublicWebsiteNavContainer.defaultProps = {
  isAmp: false,
  podcastNetwork: null,
  user: null,
  campaigns: [],
  pathname: null,
  podcastName: null,
  podcastImage: null,
};

export { PublicWebsiteNavContainer };
